/** Shared marketing headline scale — compiled from tenant `--text-marketing-*` tokens. */
export const MARKETING_DISPLAY_TITLE =
  'text-[length:var(--text-marketing-display,clamp(2rem,4.5vw,3.25rem))] leading-[1.12]'

export const MARKETING_SECTION_TITLE =
  'text-[length:var(--text-marketing-section,clamp(1.625rem,2.75vw,2.5rem))] leading-[1.12] text-[var(--marketing-text,#1f2528)]'

export const MARKETING_SECTION_TITLE_ON_DARK =
  'text-[length:var(--text-marketing-section,clamp(1.625rem,2.75vw,2.5rem))] leading-[1.12] text-white'
